import { z } from 'zod';
/**
 * Como o backend valida tokens:
 * - `entra`: só tokens reais do Entra ID (assinatura, emissor e audience).
 * - `dev`: aceita também tokens de dev, sem assinatura. Proibido em produção.
 */
export const authModeSchema = z.enum(['entra', 'dev']);
/** Resposta de `GET /api/auth/config`, pública: o frontend escolhe o login por ela. */
export const authConfigSchema = z.strictObject({
    mode: authModeSchema,
});
//# sourceMappingURL=auth-config.contract.js.map